<script>
import NextButton from 'dashboard/components-next/button/Button.vue';
import { useAlert } from 'dashboard/composables';

export default {
  components: {
    NextButton,
  },
  props: {
    webhook: {
      type: Object,
      required: true,
    },
  },
  emits: ['delete'],
  data() {
    return {
      isTesting: false,
    };
  },
  computed: {
    statusClass() {
      return this.webhook.enabled
        ? 'bg-g-50 text-g-800 dark:bg-g-800 dark:text-g-200'
        : 'bg-r-50 text-r-800 dark:bg-r-800 dark:text-r-200';
    },
    statusLabel() {
      return this.webhook.enabled
        ? this.$t('KAPTION_DELIVERY_WEBHOOKS.STATUS.ACTIVE')
        : this.$t('KAPTION_DELIVERY_WEBHOOKS.STATUS.DISABLED');
    },
    secretPrefix() {
      return this.webhook.secret_prefix
        ? `${this.webhook.secret_prefix}...`
        : '********';
    },
    eventBadges() {
      return this.webhook.events || [];
    },
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.webhook);
    },
    async onTest() {
      this.isTesting = true;
      try {
        const result = await this.$store.dispatch(
          'kaptionDeliveryWebhooks/test',
          this.webhook.id
        );
        if (result.success) {
          useAlert(
            this.$t('KAPTION_DELIVERY_WEBHOOKS.TEST.SUCCESS', {
              status: result.http_status,
              latency: result.latency_ms,
            })
          );
        } else {
          useAlert(
            this.$t('KAPTION_DELIVERY_WEBHOOKS.TEST.FAILURE', {
              error: result.error || `HTTP ${result.http_status}`,
            })
          );
        }
      } catch (error) {
        useAlert(this.$t('KAPTION_DELIVERY_WEBHOOKS.TEST.ERROR'));
      } finally {
        this.isTesting = false;
      }
    },
  },
};
</script>

<template>
  <tr>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <div class="flex flex-col">
        <span class="font-medium text-n-slate-12">{{ webhook.name }}</span>
        <span class="text-sm text-n-slate-11 font-mono truncate max-w-xs">
          {{ webhook.url }}
        </span>
      </div>
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <div class="flex flex-wrap gap-1">
        <span
          v-for="event in eventBadges"
          :key="event"
          class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-n-alpha-2 text-n-slate-11"
        >
          {{ event }}
        </span>
      </div>
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <span class="font-mono text-sm text-n-slate-11">
        {{ secretPrefix }}
      </span>
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4">
      <span
        class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium"
        :class="statusClass"
      >
        {{ statusLabel }}
      </span>
    </td>
    <td class="py-4 ltr:pr-4 rtl:pl-4 text-right">
      <div class="flex items-center justify-end gap-2">
        <NextButton
          v-if="webhook.enabled"
          slate
          faded
          xs
          icon="i-lucide-play"
          :label="$t('KAPTION_DELIVERY_WEBHOOKS.LIST.TEST')"
          :is-loading="isTesting"
          @click="onTest"
        />
        <NextButton
          v-if="webhook.enabled"
          ruby
          faded
          xs
          icon="i-lucide-trash-2"
          :label="$t('KAPTION_DELIVERY_WEBHOOKS.LIST.REVOKE')"
          @click="onDelete"
        />
        <span v-if="!webhook.enabled" class="text-sm text-n-slate-11">
          {{ $t('KAPTION_DELIVERY_WEBHOOKS.STATUS.DISABLED') }}
        </span>
      </div>
    </td>
  </tr>
</template>
